import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import { debug } from 'util';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class UserService {
  myAppUrl: string = "";
  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {    
    if (sessionStorage.getItem("BaseURL") != null && sessionStorage.getItem("BaseURL") != "") {
      this.myAppUrl = sessionStorage.getItem("BaseURL") || '';
    }
  }

  GetUserInformationbyUsername(TokenKey: string, username: string, password: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };
    return this._http.get(this.myAppUrl + "api/UserMasterAdmin/GetUserMasterFindByUsername/" + username + "/" + password, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: Response | any) {
    console.error(error.message || error);
    return Observable.throw(error.status)
  }
}
